"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = enterNextFocus;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
function enterNextFocus(e, manualScrollIntoView) {
  try {
    if (e.key === 'Enter') {
      var _findForm = function findForm(e) {
        if (e !== null && e !== void 0 && e.tagName && (e === null || e === void 0 ? void 0 : e.tagName.toLowerCase()) === 'form') {
          return e;
        } else if (e !== null && e !== void 0 && e.parentElement) {
          return _findForm(e.parentElement);
        }
      };
      var form = _findForm(e.target);
      if (form) {
        var inputs = form.querySelectorAll('input,textarea,button[type=\'submit\']');
        var currInput = e.target;
        var index = (0, _toConsumableArray2["default"])(inputs).indexOf(currInput);
        var next = inputs[index + 1];
        if (next && next.tagName.toLowerCase() === 'button') {
          var asyncFunction = /*#__PURE__*/function () {
            var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, 100);
                    });
                  case 2:
                    next.click();
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function asyncFunction() {
              return _ref.apply(this, arguments);
            };
          }();
          currInput.blur();
          asyncFunction();
        } else if (next) {
          e.preventDefault();
          if (manualScrollIntoView) {
            next.focus({
              preventScroll: true
            });
            next.scrollIntoView((0, _objectSpread2["default"])({
              block: 'center'
            }, manualScrollIntoView));
          } else {
            next.focus();
          }
        }
      }
    }
  } catch (e) {}
}